import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { Conferences, ConferencesFilters } from '../types';
import { default_new_conference_response, default_new_conference, default_conference } from '../services';

export default class ConferencesState extends BaseState {
  conferences: Conferences.Conference[] = [];
  news_conference_responce: Conferences.NewConferenceRespone = default_new_conference_response();
  new_conference: Conferences.NewConference = default_new_conference();
  organizations: string[] = [];
  statuses: string[] = [];
  conferences_loading = false;
  users_loading = false;
  conference_detail: Conferences.ConferenceDetail = default_conference();

  filters: ConferencesFilters = {
    search: '',
    organizations: [],
    statuses: [],
    dates: [],
  }

  show_success_dialog = false;
  is_edit_success_dialog = false;
  show_role_dialog = false;
  roles_message = '';

  show_not_found_dialog = false;

  add_users_fileds: Conferences.AddUser = {
    full_name: null,
    birthday: null,
    email: '',
    position: null,
    phone: null,
    user_id: null,
  }

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['created_at'],
    sortDesc: [true],
  };
}
